import React from 'react';
import ReactDOM from 'react-dom';
import './App.scss';
import App from './App.js';
const  ReactGA = require('react-ga');
ReactGA.initialize('UA-98288236-1', {debug: true});
const rootEl = document.getElementById('root');
ReactDOM.render(
  <App />,
  rootEl
);
if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    ReactDOM.render(
      <NextApp />,
      rootEl
    )
  })
}



// WEBPACK FOOTER //
// ./src/index.js